import { errorValidation } from './utils';

/**
 * Validate forms
 */
function initializeBidValidation() {
	// Bid
	$("form[name='bid']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'bid[price]': {
				required: true,
			},
			'bid[rate_per_mile]': {
				required: true,
			},
			'bid[true_rate_per_mile]': {
				required: true,
			},
			'bid[location_empty]': {
				required: true,
			},
			'bid[date_empty]': {
				required: true,
			},
			'bid[time_empty]': {
				required: true,
			},
			'bid[time_expire]': {
				required: true,
			},
		},
		messages: {
			'bid[price]': {
				required: window.translations.required,
			},
			'bid[rate_per_mile]': {
				required: window.translations.required,
			},
			'bid[true_rate_per_mile]': {
				required: window.translations.required,
			},
			'bid[location_empty]': {
				required: window.translations.required,
			},
			'bid[date_empty]': {
				required: window.translations.required,
			},
			'bid[time_empty]': {
				required: window.translations.required,
			},
			'bid[time_expire]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
}

$(document).on('click', '.get__bid', function (e) {
	e.preventDefault();
	const load_id = $(this).data('load_id');
	const connection_id = $(this).closest('.connection_container').data('id');

	addLoader('.custom__loader', 800, { height: '250px' }, function () {
		$.ajax({
			url: '/' + lang + '/bid/get', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				load_id: load_id,
				connection_id: connection_id,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.add_bid_container').remove();
					$('.wrapper').append(data.view);

					initializeBidValidation();
					AttachPopup();
					AttachPlaceholder();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
});

$(document).on('click', '.add__bid', function (event) {
	event.preventDefault();
	let bid_form = $("form[name='bid']");

	if (bid_form.valid()) {
		let bid = bid_form.serializeArray();

		let allData = {};
		$.each(bid, function (index, field) {
			allData[field.name] = field.value;
		});

		console.log('allData: ', allData);

		addLoader('.custom__loader', 800, { height: '250px' }, function () {
			$.ajax({
				url: '/' + lang + '/bid/add', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: allData,
				success: function (data) {
					if (data.status == 'ok') {
						$('.add_bid_container').replaceWith(data.view);
						AttachPopup();
					} else {
						$('.add_bid_container').replaceWith(data.view);
						AttachPopup();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	}
});
